import axios from "axios";
import { sisikong_url } from "../../../api";

const baseUrl = `${sisikong_url}/event/api/v1`;

export function markEventAsRead({
  eventId,
  username,
  sourceEntity,
}: {
  eventId: string;
  username: string;
  sourceEntity: string;
}) {
  return axios.post(`${baseUrl}/events/read/${sourceEntity}/${username}/${eventId}`);
}

export function notifyOnEventSSE(
  source_entity: string,
  user_email: string,
  setUnreadEvents: (evtUid: string) => void,
  setUserUnreadEvents: (evtUid: string, roomUid: string) => void,
): EventSource {
  const evtSource = new EventSource(`${baseUrl}/events/notify/${source_entity}/${user_email}`);
  evtSource.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      if (!data.username) {
        setUnreadEvents(data.uid);
      } else {
        if (data.event_type === "chat_message_received" && data?.data?.uid) {
          if (data.username !== user_email) {
            return;
          }
          setUserUnreadEvents(data.data.uid, data.data.room_uid);
          return;
        }
      }
    } catch {}
  };
  return evtSource;
}
